module.exports = __webpack_public_path__ + "img/img12.d4603efc.png";